import { useEffect, useState, useRef } from 'react';
import ConversationReportService from 'views/ChatConfiguration/service';
import { toast } from 'react-toastify';

/**
 * Hook para carregar a configuração de criar protocolo ao encerrar conversa
 * Faz a consulta toda vez pois é um valor que se altera
 * @returns {boolean} - Valor da configuração
 */
export const useProtocolConversationConfig = () => {
  const [shouldCreateProtocol, setShouldCreateProtocol] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    ConversationReportService.getConfigProtocolChat()
      .then((response) => {
        const { criarProtocoloParaConversaNoMonitoramento } = response.data;

        if (isMountedRef.current) {
          setShouldCreateProtocol(criarProtocoloParaConversaNoMonitoramento);
        }
      })
      .catch((error) => {
        console.error('Erro ao carregar configurações:', error);
        if (error.response) {
          toast.error('Erro ao carregar configurações!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return shouldCreateProtocol;
};
